import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { Section, SectionHeading, Reveal, CTASection, Button } from "@/components/ui-bits";
import { PageHero, FlowDiagram, PhotoPlaceholder } from "@/components/shared";
import { IMG } from "@/lib/data";
import { Check } from "lucide-react";

const SUPPORT = ["Product concept development", "Custom formulation", "Ingredient selection", "Flavour direction", "Formula refinement", "Sample development", "Product iteration", "Manufacturing preparation", "Packaging format selection"];

export default function ProductDevelopment() {
  useSEO("Custom Beverage Formulation & Product Development | Wisperwick Studio",
    "Turn a beverage idea into a manufacturable product — concept development, custom formulation, ingredient selection, flavour direction and sampling.");
  return (
    <div>
      <PageHero eyebrow="Formulation & product development" title="From concept to formulation."
        sub="Not sure how your idea becomes a real beverage? Start with the concept." />

      <Section className="pt-0">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <Reveal>
            <PhotoPlaceholder src={IMG.powder1} alt="Formulation and ingredient development" label="FORMULATION / PRODUCT DEVELOPMENT — REPLACE WITH ACTUAL PHOTOGRAPHY" ratio="aspect-[4/3]" />
          </Reveal>
          <div>
            <SectionHeading eyebrow="What we support" title="We help make a founder's idea manufacturable." />
            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mt-8">
              {SUPPORT.map((s, i) => (
                <Reveal key={s} delay={i * 0.04}>
                  <div className="flex items-start gap-2.5 text-sm text-ws-dark">
                    <Check className="w-4 h-4 text-ws-accent shrink-0 mt-0.5" strokeWidth={2.4} /> {s}
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </Section>

      <Section bg="var(--ws-bg2)">
        <SectionHeading eyebrow="The development process" title="Concept to production." align="center" className="mx-auto" />
        <Reveal delay={0.1}>
          <div className="mt-14 flex justify-center">
            <FlowDiagram items={["Concept", "Formulation", "Sample", "Refine", "Production"]} />
          </div>
        </Reveal>
        <Reveal delay={0.2}><p className="text-center text-ws-text2 max-w-2xl mx-auto mt-12">Written for founders — no food-science background required. We translate an idea into ingredients, flavour, function and format.</p></Reveal>
        <div className="flex justify-center mt-10"><Button to="/request-a-quote" testid="pd-cta">Discuss Your Formulation</Button></div>
      </Section>

      <CTASection />
    </div>
  );
}
